export const BASE_URL = "https://recipe-site-backend-baa4.onrender.com";

// export const BASE_URL = "http://localhost:3002";
